import { state } from "../context/store";

const updateNumber = (number) => {
  if (state.current.choices.raceNumber.selected.number.length > 2) {
    let trimmedNumber =
      state.current.choices.raceNumber.selected.number.substring(1);
    state.current.choices.raceNumber.selected.number = trimmedNumber + number;
  } else {
    let combinedNumber =
      state.current.choices.raceNumber.selected.number + number;
    state.current.choices.raceNumber.selected.number = combinedNumber;
  }
};
const updateBadgeNumber = (number) => {
  console.log(number);
  if (state.current.choices.superBadge.selected.number.length > 2) {
    let trimmedNumber =
      state.current.choices.superBadge.selected.number.substring(1);
    state.current.choices.superBadge.selected.number = trimmedNumber + number;
  } else {
    let combinedNumber =
      state.current.choices.superBadge.selected.number + number;
    state.current.choices.superBadge.selected.number = combinedNumber;
  }
};

const resetNumbers = () => {
  state.current.choices.raceNumber.selected = {
    mode: "number",
    name: "White",
    number: "",
    hex: "#ddd",
    font: "old-english.ttf",
  };
  state.current.status.confirmRemoveNumber = false;
};
const resetBadgeNumbers = () => {
  state.current.choices.superBadge.selected.number = "";
};

const selectNumberColor = () => {
  console.log("what");
  state.current.status.numberSelectMode = "color";
};
const selectBadgeNumberColor = () => {
  console.log(state.current.status.badgeNumberMode);
  state.current.status.badgeNumberMode = "color";
  console.log(state.current.status.badgeNumberMode);
};

export {
  updateNumber,
  resetNumbers,
  selectNumberColor,
  updateBadgeNumber,
  resetBadgeNumbers,
  selectBadgeNumberColor
};
